import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'
import {PrimerComponentHeroSchema} from './primerComponentHero'

/**
 * Schema for Rendering Strategy content type.
 * Defines conditional component rendering based on user state.
 *
 * Strategy evaluation follows a match-first pattern:
 * - The first strategy whose condition matches is used
 * - If no strategies match, the default component is rendered
 *
 * Currently supports:
 * - LOGGED_IN: User authentication state
 *
 * Future expansion could include:
 * - ORG_MEMBERSHIP: User has organization
 * - SUBSCRIPTION_TIER: User's plan level
 * - UTM_PARAMS: Marketing campaign tracking
 */
export const RenderingStrategySchema = buildEntrySchemaFor('swpRenderingStrategy', {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      strategy: z.enum(['LOGGED_IN']),
      component: PrimerComponentHeroSchema,
    }),
  ),
})

export type RenderingStrategy = z.infer<typeof RenderingStrategySchema>
